import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { usePersona } from "@/lib/persona";

export const Route = createFileRoute("/app/profile")({
  component: PartnerProfileStub,
});

/**
 * Partner-only route — edit the org's public profile (bio, photos, social).
 */
function PartnerProfileStub() {
  const persona = usePersona();
  if (persona.role !== "partner") return <Navigate to="/app" replace />;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-serif text-3xl text-palm">Organization profile</h1>
        <p className="text-muted-foreground">
          Edit the public-facing bio, photos, website, social handles.
        </p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>Coming in M1</CardTitle>
          <CardDescription>
            Backed by the same `partners` + role-specific detail tables in Neon. Edits trigger
            audit-log writes and require Cognito group `partner` on the row's tenant.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          When this lands you'll have form fields for org name, contact, social links, plus the
          R2 photo dropzone reused from the public signup.
        </CardContent>
      </Card>
    </div>
  );
}
